export function mapProductData(data) {
    console.log("mapProductData running...");
    try {
        if (!data || typeof data !== 'object') {
            throw new Error('Invalid input: data must be a non-null object');
        }

        if (!Array.isArray(data.variants)) {
            throw new Error('Invalid input: data.variants must be an array');
        }

        const productData = {
            id: data.id || null,
            handle: data.handle || '',
            tags: Array.isArray(data.tags) ? data.tags : [],
            available: Boolean(data.available),
            variants: data.variants.map(variant => ({
                id: variant.id || null,
                title: variant.title || '',
                available: Boolean(variant.available),
                inventory_quantity: variant.inventory_quantity || 0,
                inventory_management: variant.inventory_management || ''
            }))
        };

        const productDataStr = JSON.stringify(productData);

        // Escape special characters for safe embedding in HTML
        return productDataStr
            .replace(/&/g, '&amp;')  // Escape ampersand
            .replace(/"/g, '&quot;') // Escape double quotes
            .replace(/'/g, '&#39;')  // Escape single quotes
            .replace(/</g, '&lt;')   // Escape less-than
            .replace(/>/g, '&gt;');  // Escape greater-than
    } catch (error) {
        console.error('Error mapping product data:', error.message);
        return '';
    }
}